import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    width: '100%',
    gap: theme.spacing[5],
  },
  scrollContainer: {
    flex: 1,
  },
  scrollContainerContent: (monthGap: number, trailingPadding: number) => ({
    columnGap: monthGap,
    paddingRight: trailingPadding,
  }),
  monthPage: {
    flex: 1,
  },

  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing[4],
    paddingHorizontal: theme.spacing[3],
  },
  monthText: {
    // marginBottom: theme.spacing[6],
    color: colors.textPrimary,
  },
  weekContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: theme.spacing[3],
    gap: theme.spacing[3],
  },
  monthContainer: (width: number) => ({
    width,
  }),
  monthTitles: {
    flex: 1,
    flexDirection: 'row',
  },
  leadingMonthTitle: (monthStride: number) => ({
    width: monthStride,
  }),
  navigationContainer: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    // alignItems: 'center',
    gap: theme.spacing[2],
  },
  todayButton: {
    paddingHorizontal: theme.spacing[4],
    marginRight: theme.spacing[4],
  },
  arrowButton: {
    paddingHorizontal: theme.spacing[3],
    borderRadius: theme.borderRadius.full,
    aspectRatio: 1,
  },
  navigationButtonsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing[2],
  },
  weekRow: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    rowGap: theme.spacing[3],
    columnGap: theme.spacing[5],
    marginBottom: theme.spacing[3],
  },
  weekDayLabels: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginBottom: theme.spacing[6],
    gap: theme.spacing[3],
  },
  navigationButton: {
    aspectRatio: 1,
    minWidth: 40,
  },
  dayContainer: {
    flex: 1,
    aspectRatio: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  dayCircle: {
    width: '100%',
    aspectRatio: 1,
    borderRadius: theme.borderRadius.full,
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',

    variants: {
      fill: {
        available: {
          backgroundColor: colors.calendarDayBackground,
        },
        // SQR-14330: a day with no open slots but a live waitlist is still
        // actionable, so it renders exactly like an available day (WoM parity).
        waitlistOnly: {
          backgroundColor: colors.calendarDayBackground,
        },
        disabled: {
          backgroundColor: colors.backgroundL2,
        },
        outOfRange: {
          backgroundColor: colors.backgroundL1Alpha,
        },
        hidden: {
          opacity: 0,
        },
      },
    },
  },
  dayText: {
    color: colors.calendarDayText,
    variants: {
      fill: {
        available: {
          color: colors.calendarDayText,
        },
        waitlistOnly: {
          color: colors.calendarDayText,
        },
        disabled: {
          color: colors.textDisabled,
        },
        outOfRange: {
          color: colors.textDisabled,
        },
        hidden: {
          opacity: 0,
        },
      },
    },
  },
  indicatorRing: {
    padding: 2,
    borderWidth: 1,
    borderRadius: theme.borderRadius.full,
    borderColor: 'transparent',
    variants: {
      selected: {
        true: {
          borderColor: colors.textPrimary,
        },
      },
    },
  },
  todayIndicator: {
    width: 4,
    height: 4,
    borderRadius: theme.borderRadius.full,
    backgroundColor: colors.backgroundPrimary,
    variants: {
      fill: {
        available: {
          backgroundColor: colors.backgroundPrimary,
        },
        waitlistOnly: {
          backgroundColor: colors.backgroundPrimary,
        },
        disabled: {
          backgroundColor: colors.textDisabled,
        },
      },
    },
  },
}));
